module.exports = __webpack_public_path__ + "static/media/footui_9.a051ff07.gif";